import { Stack, styled } from '@mui/material'

/** Style Container for message tiles */
export const StyledContainer = styled(Stack)(({ theme }) => {
  return {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',

    borderColor: theme.palette.shades.shade03,
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.shape.borderRadius,
  }
})
